<script>
    import { onMount } from "svelte";
    import { ModalBody, Modal, ModalHeader } from "sveltestrap";
    import UploadSecrets from "./UploadSecrets.svelte";
    import Select from "svelte-select";
    import { 
        PROVIDER_TEMPLATES, 
        buildKeyFromPattern, 
        getProviderTemplate,
        REVERSE_API_PROVIDERS,
        REVERSE_API_REGEX,
        extractReverseApiProviderCode
    } from "../../../../js/providersTemplates.js";
    import backend from "../../../../server";
    import { ICONS } from "../../../../js/icons";
    import alertify from "alertifyjs";
    import UpdateEndpointModal from "./UpdateEndpointModal.svelte";
    import GenerateCredentialsModal from "./GenerateCredentialsModal.svelte";

    export let showModalUploadCredentials2;

    let credentials = [];
    let clientFilter = "";
    let providerFilter = "";
    let filteredCredentials = [];
    let platforms = [];
    let providers = [];
    let platformsByCode = {};
    let providersByCode = {};
    let secretsKey = 0;
    let showUpdateEndpointModal = false;
    let showGenerateCredentialsModal = false;
    let activeEnv = "prod"; // "prod" | "test"
    let reverseApiInitialValues = null;

    const nameForPlatform = (code) => platformsByCode[String(code || "").toLowerCase()]?.namesite || (code || "");
    const nameForProvider = (code) => providersByCode[String(code || "").toLowerCase()]?.name || (code || "");

    let selectedProvider = null;
    let selectedPlatform = null;
    let openNewModal = false;
    let loading = false;
    let platformValue = { value: "", label: "Todas" };
    let providerValue = { value: "", label: "Todos" };

    $: platformItems = [
        { value: "", label: "Todas" },
        ...platforms.map(p => ({ value: String(p.code), label: p.namesite }))
    ];
    $: providerItems = [
        { value: "", label: "Todos" },
        ...providers.map(p => ({ value: String(p.code), label: p.name }))
    ];

    let patternIndex = [];
    const metaCache = new Map();
    const escapeRegex = (s) => s.replace(/[-[\]/{}()*+?.\\^$|]/g, "\\$&");
    const compilePatternWithGroups = (pattern) => {
        const re = /\$\{(platform|currency)\}/g;
        let lastIdx = 0, out = "^";
        const groups = [];
        for (const m of pattern.matchAll(re)) {
            out += escapeRegex(pattern.slice(lastIdx, m.index));
            out += "([A-Za-z0-9._-]+)";
            groups.push(m[1]);
            lastIdx = m.index + m[0].length;
        }
        out += escapeRegex(pattern.slice(lastIdx)) + "$";
        return { regex: new RegExp(out, "i"), groups };
    };
    const buildPatternIndex = () => {
        patternIndex = [];
        for (const [providerCode, tpl] of Object.entries(PROVIDER_TEMPLATES)) {
            for (const field of (tpl?.fields || [])) {
                if (!field?.pattern) continue;
                const { regex, groups } = compilePatternWithGroups(field.pattern);
                patternIndex.push({ regex, groups, providerCode, label: field.label || "" });
            }
        }
    };
    const switchEnv = (env) => {
        activeEnv = env;
        credentials = [];
        filteredCredentials = [];
        clientFilter = "";
        providerFilter = "";
        selectedPlatform = null;
        selectedProvider = null;
        platformValue = { value: "", label: "Todas" };
        providerValue = { value: "", label: "Todos" };
        metaCache.clear();
        REVERSE_API_PROVIDERS.clear();
        listProviders();
        if (env === "test") {
            listCredentials();
            if (platforms.length) {
            const demofront = platforms.find(p =>
                String(p.code).toLowerCase() === "demofront" ||
                String(p.namesite).toLowerCase() === "demofront"
            );
            if (demofront) {
                platformValue = { value: String(demofront.code), label: demofront.namesite };
                clientFilter = String(demofront.code);
                selectedPlatform = demofront;
            }
        }
    }
    };
    const inferMetaForKey = (keyId) => {
        const s = String(keyId);
        const cached = metaCache.get(s);
        if (cached) return cached;
        for (const entry of patternIndex) {
            const m = entry.regex.exec(s);
            if (!m) continue;
            let platformCode = "";
            let currencyCode = "";
            entry.groups.forEach((name, idx) => {
                if (name === "platform") platformCode = m[idx + 1] || "";
                if (name === "currency") currencyCode = m[idx + 1] || "";
            });
            const result = {
                _platform: platformCode,
                _currency: currencyCode,
                _providerCode: String(entry.providerCode).toLowerCase(),
                displayLabel: entry.label?.trim() ? entry.label : keyId,
            };
            metaCache.set(s, result);
            return result;
        }
        // Fallback: patrón genérico de Reverse API
        // Detecta: {providerCode}_{PLATFORM}.{field}
        const reverseApiRegex = /^([a-z0-9]+)_([A-Z0-9]{2,6})\.(auth|launch_url|private_key|site_id)$/i;
        const reverseMatch = reverseApiRegex.exec(s);
        if (reverseMatch) {
            const result = {
                _platform: reverseMatch[2],
                _currency: "",
                _providerCode: reverseMatch[1].toLowerCase(),
                displayLabel: reverseMatch[3],
            };
            metaCache.set(s, result);
            return result;
        }
        const result = { _platform: "", _currency: "", _providerCode: "", displayLabel: keyId };
        metaCache.set(s, result);
        return result;
    };
    const shouldHideKey = (key) => {
        const s = String(key || "").toLowerCase();
        return s.includes("token_client_request") || s.includes("currencies");
    };

    // grupo actual
    const getCurrentGroupItems = (selectedPlatform, selectedProvider, filteredCredentials) => {
        if (!selectedPlatform || !selectedProvider) return [];
        const pCode = String(selectedPlatform.code || selectedPlatform).toLowerCase();
        const vCode = String(selectedProvider.code || selectedProvider).toLowerCase();
        return filteredCredentials.filter(c =>
            String(c._platform || '').toLowerCase() === pCode &&
            String(c._providerCode || '').toLowerCase() === vCode
        );
    };
    $: currentGroupItems = getCurrentGroupItems(selectedPlatform, selectedProvider, filteredCredentials);
    $: hasContent = currentGroupItems.length > 0;

    const mostCommon = (arr) => {
        const m = new Map();
        for (const v of arr) m.set(v, (m.get(v) || 0) + 1);
        let ans = null, cnt = -1;
        for (const [k, c] of m) if (c > cnt) { ans = k; cnt = c; }
        return ans;
    };

    const buildInitialValuesFromGroup = (items) => {
        if (!selectedProvider || !selectedPlatform) return null;
        const provCode = String(selectedProvider.code).toLowerCase();
        const tpl = getProviderTemplate(provCode); // ← ahora sí pasa por el fallback
        if (!tpl) return null;

        const platformCode = String(selectedPlatform.code || '');
        const currencies = Array.from(new Set(items.map(i => String(i._currency || '').trim().toUpperCase()).filter(Boolean)));
        const currency = currencies[0] || '';

        const values = {};
        for (const f of (tpl.fields || [])) {
            const secretName = buildKeyFromPattern(f.pattern, { 
                platform: platformCode, 
                currency: currency || "",
                providerCode: provCode
            });
            const row = items.find(it => String(it.keyId).toLowerCase() === String(secretName).toLowerCase());
            values[f.pattern] = row ? row.value : "";
        }
        const env = Number(mostCommon(items.map(i => Number(i.section)))) || 1;
        return { platform: platformCode, currency, currencies, values, env, section: env };
    };

    const isReverseApiProvider = (providerCode) => {
        return REVERSE_API_PROVIDERS.has(String(providerCode || "").toLowerCase());
    };

    const buildReverseApiInitialValues = (items) => {
        const provCode = String(selectedProvider?.code || "").toLowerCase();

        const authItem = items.find(i => i.displayLabel === "auth");
        const launchItem = items.find(i => i.displayLabel === "launch_url");
        const siteIdItem = items.find(i => i.displayLabel === "site_id");

        let providerUsername = "";
        if (authItem?.value) {
            try {
                const decoded = atob(authItem.value);
                const beforeColon = decoded.split(":")[0];
                const lastUnderscore = beforeColon.lastIndexOf("_");
                providerUsername = lastUnderscore !== -1
                    ? beforeColon.slice(0, lastUnderscore)
                    : beforeColon;
            } catch (e) {
                console.error("Error decodificando auth:", e);
            }
        }

        return {
            providerName: selectedProvider?.name || "",
            providerCode: provCode,
            providerUsername,
            siteId: siteIdItem?.value || "",
            launchUrl: launchItem?.value || "",
        };
    };

    const onEditClick = () => {
        secretsKey += 1;
        if (hasContent && activeEnv === "test" && isReverseApiProvider(selectedProvider?.code)) {
            reverseApiInitialValues = buildReverseApiInitialValues(currentGroupItems);
            showGenerateCredentialsModal = true;
        } else {
            openNewModal = true;
        }
    };

    const openReverseCredentialsGenerator = () => {
        const canHydrateReverseProvider =
            activeEnv === "prod" &&
            hasContent &&
            isReverseApiProvider(selectedProvider?.code);

        reverseApiInitialValues = canHydrateReverseProvider
            ? buildReverseApiInitialValues(currentGroupItems)
            : null;
        showGenerateCredentialsModal = true;
    };

    const copyValue = async (value) => {
        try {
            await navigator.clipboard.writeText(String(value ?? ''));
            alertify.success('Copiado');
        } catch (e) {
            alertify.error('No se pudo copiar');
            console.error(e);
        }
    };

    const sortCreds = (arr) => arr.sort((a, b) => {
        const s = (x) => String(x || "");
        let r = s(a._platform).localeCompare(s(b._platform));
        if (r) return r;
        r = s(a._providerName || a._providerCode).localeCompare(s(b._providerName || b._providerCode));
        if (r) return r;
        const ac = a._currency ? a._currency : "\uFFFF";
        const bc = b._currency ? b._currency : "\uFFFF";
        r = s(ac).localeCompare(s(bc));
        if (r) return r;
        return s(a.displayLabel).localeCompare(s(b.displayLabel));
    });

    onMount(() => {
        buildPatternIndex();
        listPlatforms();
        listProviders();
    });

    const listCredentials = async () => {
        if (loading) return;
        loading = true;
        try {
            const response = activeEnv === "prod"
            ? await backend.client.listCredentialsGames("prod")
            : await backend.client.listCredentialsGames("test");
            // Limpiar y reconstruir dinámicamente
            REVERSE_API_PROVIDERS.clear();
            const allCredentials = Object.entries(response.data).flatMap(
                ([section, creds]) =>
                    Object.entries(creds)
                        .filter(([key]) => !shouldHideKey(key))
                        .map(([key, value]) => {
                            // Poblar el Set dinámicamente
                            const provCode = extractReverseApiProviderCode(key);
                            if (provCode) REVERSE_API_PROVIDERS.add(provCode);
                            const meta = inferMetaForKey(key);
                            return {
                                keyId: key,
                                value,
                                section,
                                displayLabel: meta.displayLabel,
                                _platform: meta._platform,
                                _currency: meta._currency,
                                _providerCode: meta._providerCode,
                                _platformName: nameForPlatform(meta._platform),
                                _providerName: nameForProvider(meta._providerCode),
                            };
                        })
            );
            sortCreds(allCredentials);
            credentials = allCredentials;
            filterCredentials();
            loading = false;
        } catch (error) {
            alertify.error("Error al listar las credenciales");
            loading = false;
        }
    };

    const filterCredentials = () => {
        const platformCode = (clientFilter || "").toLowerCase().trim();
        const providerCode = (providerFilter || "").toLowerCase().trim();
        filteredCredentials = credentials.filter((cred) => {
            if (shouldHideKey(cred.keyId)) return false;

            let platformMatch = true;
            if (platformCode) {
                const inferred = String(cred._platform || "").toLowerCase();
                platformMatch = inferred === platformCode
                    || (cred.keyId && cred.keyId.toLowerCase().includes(platformCode));
            }

            let providerMatch = true;
            if (providerCode) {
                const tokens = getProviderFilter(providerCode);
                const inferredProv = String(cred._providerCode || "").toLowerCase();
                providerMatch = tokens.includes(inferredProv)
                    || matchesAnyToken((cred.keyId || "").toLowerCase(), tokens);
            }

            return platformMatch && providerMatch;
        });
        sortCreds(filteredCredentials);
    };

    const listPlatforms = async () => {
        const params = { platform: 1, xpage: 400, page: 1 };
        const response = await backend.client.list(params);
        platforms = response.data.list.sort((a, b) =>
            a.namesite.toLowerCase().localeCompare(b.namesite.toLowerCase())
        );
        platformsByCode = {};
        for (const p of platforms) platformsByCode[String(p.code).toLowerCase()] = p;

        if (credentials.length) {
            credentials = credentials.map(c => ({ ...c, _platformName: nameForPlatform(c._platform) }));
            filterCredentials();
        }
    };

    const listProviders = async () => {
        providers = await backend.provider.list({ environment: activeEnv });
        providers.sort((a, b) => a.name.toLowerCase().localeCompare(b.name.toLowerCase()));
        providersByCode = {};
        for (const p of providers) providersByCode[String(p.code).toLowerCase()] = p;

        if (credentials.length) {
            credentials = credentials.map(c => ({ ...c, _providerName: nameForProvider(c._providerCode) }));
            filterCredentials();
        }
    };

    const getProviderFilter = (code) => {
        if (!code) return [];
        const tpl = PROVIDER_TEMPLATES[String(code).toLowerCase()];
        if (tpl && Array.isArray(tpl.filter) && tpl.filter.length) {
            return tpl.filter.map(t => String(t).toLowerCase());
        }
        return [String(code).toLowerCase()];
    };
    const matchesAnyToken = (textLower, tokens) => tokens.some(t => t && textLower.includes(t));

    $: hasAnyCurrency = filteredCredentials.some(c => !!c._currency);
    $: filterCredentials();

    function onPlatformSelect(e) {
        const item = e.detail;
        if (item && item.value) {
            const platform = platforms.find(p => String(p.code) === item.value);
            clientFilter = String(item.value);
            selectedPlatform = platform || { code: item.value, namesite: item.label };
            platformValue = item;
        } else {
            clientFilter = "";
            selectedPlatform = null;
            platformValue = { value: "", label: "Todas" };
        }
        if (!credentials.length && (clientFilter || providerFilter)) listCredentials();
        if (!clientFilter && !providerFilter) { credentials = []; filteredCredentials = []; }
        else filterCredentials();
    }

    function onProviderSelect(e) {
        const item = e.detail;
        if (item && item.value) {
            const provider = providers.find(p => String(p.code) === item.value);
            providerFilter = String(item.value);
            selectedProvider = provider || { code: item.value, name: item.label };
            providerValue = item;
        } else {
            providerFilter = "";
            selectedProvider = null;
            providerValue = { value: "", label: "Todos" };
        }
        if (!credentials.length && (clientFilter || providerFilter)) listCredentials();
        if (!clientFilter && !providerFilter) { credentials = []; filteredCredentials = []; }
        else filterCredentials();
    }

    const onShowModalUploadCredentials2 = () =>
        (showModalUploadCredentials2 = !showModalUploadCredentials2);
</script>

<Modal
        isOpen={showModalUploadCredentials2}
        toggle={onShowModalUploadCredentials2}
        size="xl"
        contentClass="parent-content"
>
    <ModalHeader toggle={onShowModalUploadCredentials2}>CREDENCIALES
        <button
            class="btn btn-success btn-sm"
            style="margin-left: 1rem;"
            on:click={() => (showUpdateEndpointModal = true)}>
            Actualizar Endpoint
        </button>
        <button
            class="btn btn-success btn-sm"
            style="margin-left: 1rem;"
            on:click={openReverseCredentialsGenerator}>
            Reverse Credentials Generate
        </button>
    </ModalHeader>
    <ModalBody>
        <div class="env-tabs">
            <button
                class="env-tab {activeEnv === 'prod' ? 'active' : ''}"
                on:click={() => switchEnv('prod')}
            >
                Producción
            </button>
            <button
                class="env-tab {activeEnv === 'test' ? 'active' : ''}"
                on:click={() => switchEnv('test')}
            >
                Test
            </button>
        </div>
        <div class="filter-section">
            <div>
                <span>Plataforma:</span>
                <Select
                    items={platformItems}
                    bind:value={platformValue}
                    placeholder="Buscar..."
                    on:select={onPlatformSelect}
                    on:clear={onPlatformSelect}
                    optionIdentifier="value"
                    labelIdentifier="label"
                    isSearchable={true}
                    containerStyles=""
                />
            </div>

            <div>
                <span>Proveedor:</span>
                <Select
                    items={providerItems}
                    bind:value={providerValue}
                    placeholder="Buscar..."
                    on:select={onProviderSelect}
                    on:clear={onProviderSelect}
                    optionIdentifier="value"
                    labelIdentifier="label"
                    isSearchable={true}
                    containerStyles=""
                />
            </div>

            <div class="d-flex align-items-end">
                <button
                        class="btn btn-primary w-100 action-btn"
                        on:click={() => hasContent ? onEditClick() : onEditClick()}
                        disabled={!selectedPlatform || !selectedProvider}
                >
                    {hasContent ? 'Edición' : 'Agregar nuevo'}
                </button>
            </div>
        </div>

        <div class="credentials-section">
            <div class="section-label">Credenciales Existentes:</div>
            {#if loading}
                <div class="loading-overlay">
                    <div class="spinner-border text-primary" role="status">
                        <span class="visually-hidden">Cargando...</span>
                    </div>
                    <span>Cargando credenciales...</span>
                </div>
            {:else if !filteredCredentials.length}
                <div class="empty-state">
                    {#if selectedPlatform || selectedProvider}
                        Sin resultados para los filtros seleccionados
                    {:else}
                        Selecciona una plataforma y/o proveedor para ver las credenciales
                    {/if}
                </div>
            {/if}
            {#if filteredCredentials.length && !loading}
            <div class="table-container">
                <table class="table table-striped table-sm">
                    <thead class="table-dark">
                    <tr>
                        <th>PLATAFORMA</th>
                        <th>PROVEEDOR</th>
                        {#if hasAnyCurrency}<th>MONEDA</th>{/if}
                        <th>CLAVE</th>
                        <th>VALOR</th>
                    </tr>
                    </thead>
                    <tbody>
                    {#each filteredCredentials as cred}
                        <tr>
                            <td><input class="form-control" value={cred._platformName} disabled /></td>
                            <td><input class="form-control" value={cred._providerName} disabled /></td>
                            {#if hasAnyCurrency}
                                <td><input class="form-control" value={cred._currency || ""} disabled /></td>
                            {/if}
                            <td><input class="form-control" value={cred.displayLabel} disabled /></td>
                            <td class="value-cell">
                                <button
                                        class="copy-btn"
                                        title="Copiar valor"
                                        aria-label="Copiar"
                                        on:click={() => copyValue(cred.value)}
                                >
                                    {@html ICONS.clipboard}
                                </button>
                                <input class="form-control value-input" value={cred.value} disabled />
                            </td>
                        </tr>
                    {/each}
                    </tbody>
                </table>
            </div>
            {/if}
        </div>
        
    </ModalBody>
    {#if showUpdateEndpointModal}
        <UpdateEndpointModal on:close={() => (showUpdateEndpointModal = false)} />
    {/if}
    {#if showGenerateCredentialsModal}
        <GenerateCredentialsModal
            clientCode={selectedPlatform?.code || ""}
            platforms={platforms}
            initialValues={reverseApiInitialValues}
            lockEnvironment={reverseApiInitialValues !== null}
            on:close={() => { 
                showGenerateCredentialsModal = false;
                reverseApiInitialValues = null;
            }}
        />
    {/if}
    {#if openNewModal}
        <div class="veil-in-parent"></div>
    {/if}
</Modal>

{#key secretsKey}
    <UploadSecrets
            bind:open={openNewModal}
            mode={hasContent ? 'edit' : 'create'}
            activeEnv={activeEnv}
            initialValues={
              hasContent
                ? buildInitialValuesFromGroup(currentGroupItems)
                : { platform: selectedPlatform?.code || '', currency: '', values: {}, env: Number(selectedProvider?.env || 1), section: Number(selectedProvider?.env || 1) }
            }
            onClose={() => { openNewModal = false; listCredentials(); }}
            provider={selectedProvider}
            platform={selectedPlatform}
    />
{/key}

<style>
    * { font-size: 1.2rem; }

    input:disabled {
        outline: none;
        border: none;
        font-size: 1.2rem;
        width: 90%;
    }
    input:enabled {
        border: 1px solid #c2bcbc;
        width: 100%;
        font-size: 1.2rem;
    }

    .filter-section{
        display:grid;
        grid-template-columns: 1fr 1fr 12rem;
        gap:.5rem;
    }
    .filter-section > div > span{
        display:block;
        margin-bottom:.25rem;
        font-weight:500;
    }

    .credentials-section { display: flex; flex-direction: column; gap: 0.5rem; }
    .table-container { max-height: 70vh; overflow-y: auto; }
    .veil-in-parent {
        position: absolute; inset: 0; background: rgba(0,0,0,.38);
        backdrop-filter: blur(1px); border-radius: .5rem; z-index: 2;
        pointer-events: auto; cursor: not-allowed;
    }
    .action-btn{ inline-size: 12rem; white-space: nowrap; text-overflow: ellipsis; overflow: hidden; }

    .credentials-section .table thead th { text-align: left; vertical-align: middle; }
    .credentials-section .table tbody td { text-align: left; }
    .credentials-section .table .form-control[disabled],
    .credentials-section .table .form-control:disabled {
        background-color: transparent !important;
        border: 0 !important; box-shadow: none !important; padding: 0 !important;
        height: auto; line-height: 1.25; border-radius: 0; color: inherit;
    }
    .credentials-section .table td .form-control[disabled] {
        white-space: nowrap; overflow: hidden; text-overflow: ellipsis;
    }
    .value-cell { display: flex; align-items: center; gap: .25rem; }
    .copy-btn {
        border: 0; background: transparent; padding: 0;
        inline-size: 1.25rem; block-size: 1.25rem;
        display: inline-flex; align-items: center; justify-content: center;
        opacity: .35; transition: opacity .15s ease, transform .08s ease;
        flex: 0 0 auto; cursor: pointer;
    }
    .value-cell:hover .copy-btn { opacity: .8; }
    .copy-btn:active { transform: scale(.95); }
    .value-input { min-width: 0; white-space: nowrap; overflow: hidden; text-overflow: ellipsis; }
    .section-label{ display:block; font-weight:600; margin: .5rem 0 .25rem; }
    .helper-text { font-weight:400; color:#6c757d; font-size:.9rem; }

    .loading-overlay {
        display: flex; align-items: center; gap: .75rem;
        padding: 2rem; justify-content: center;
        color: #6c757d;
    }
    .empty-state {
        padding: 2rem; text-align: center;
        color: #6c757d; font-style: italic;
    }

    :global(.svelte-select) {
        border: 1px solid #ced4da !important;
        border-radius: .375rem !important;
        min-height: 42px !important;
        --font-size: 1.2rem;
        --list-max-height: 700px;
    }
    :global(.svelte-select.focused) {
        border-color: #86b7fe !important;
        box-shadow: 0 0 0 .25rem rgba(13,110,253,.25) !important;
    }
    :global(.svelte-select .input-container) {
        padding: .5rem .75rem !important;
    }
    :global(.svelte-select .input-container input) {
        font-size: 1.2rem !important;
    }
    :global(.svelte-select .list-container) {
        z-index: 12 !important;
    }
    :global(.svelte-select .list-container .list-item) {
        padding: .5rem .75rem !important;
        font-size: 0.5rem !important;
    }
    :global(.svelte-select .list-container .list-item.active) {
        background: #0d6efd !important;
        color: #fff !important;
    }
    :global(.svelte-select .list-container .list-item.hover) {
        background: #0d6efd !important;
        color: #fff !important;
    }
    :global(.svelte-select .list-container .list-item.selected) {
        background: #e9ecef !important;
        font-weight: 500 !important;
        color: #212529 !important;
    }
    :global(.svelte-select .singleClear) {
        color: #6c757d !important;
    }

    .env-tabs {
        display: flex;
        gap: 0;
        margin-bottom: 1rem;
        border-bottom: 2px solid #dee2e6;
    }
    .env-tab {
        padding: .5rem 1.5rem;
        border: none;
        background: transparent;
        font-weight: 500;
        color: #6c757d;
        cursor: pointer;
        border-bottom: 3px solid transparent;
        margin-bottom: -2px;
        transition: all .15s ease;
    }
    .env-tab.active {
        color: #0d6efd;
        border-bottom-color: #0d6efd;
    }
    .env-tab:hover:not(.active) {
        color: #343a40;
        background: rgba(0,0,0,.04);
    }
</style>
